import React, { Component } from 'react'
import Firebase from "firebase/app"
import 'firebase/database'

import {GenericTable} from '../Utils'

import {parseEvents} from '../../utils'


class NotificationsAdmin extends Component {

    constructor(props){
        super(props)
        this.state = {
            events: {},
            reservations: {}
        }
        this.wheelChairHeaders = [
            {name: 'ID del evento', small: true},
            {name: 'ID reservacion', small: true},
            {name: 'Hora reservacion', small: true, render: 'time'},
            {name: 'Sala', small: true},
            {name: 'Nombre', small: false},
            {name: 'Telefono', small: true},
            {name: 'Correo', small: true}
        ]

        this.productsHeaders = [
            {name: 'ID del evento', small: true},
            {name: 'ID reservacion', small: true},
            {name: 'Hora reservacion', small: true, render: 'time'},
            {name: 'Sala', small: true},
            {name: 'Productos', small: true},
            {name: 'Total', small: true, render: 'money'},
            {name: 'Nombre', small: false},
            {name: 'Telefono', small: true},
            {name: 'Correo', small: true}
        ]

        this.eventsHeaders = [
            {name: 'ID del evento', small: true},
            {name: 'ID del cliente', small: true},
            {name: 'Nombre del fallecido', small: false},
            {name: 'Fecha', small: true, render: 'date'},
            {name: 'Inicio', small: true, render: 'time'},
            {name: 'Final', small: true, render: 'time'},
            {name: 'Sala', small: true},
            {name: 'Total invitados', small: true}
        ]

        this.getWheelChairNotifications = this.getWheelChairNotifications.bind(this)
        this.getProductsNotifications = this.getProductsNotifications.bind(this)
        this.getEventsTableData = this.getEventsTableData.bind(this)
    }

    getWheelChairNotifications(){
        const {reservations, events} = this.state
        const result = []
        for (var eventId in events){
            for (var reservationId in reservations[eventId]){
                if (reservations[eventId][reservationId].wheelChair){
                    const wheelChairNotification = [
                        eventId,
                        reservationId,
                        reservations[eventId][reservationId].selectedTime,
                        events[eventId].room.name,
                        reservations[eventId][reservationId].personalData.name,
                        reservations[eventId][reservationId].personalData.phone,
                        reservations[eventId][reservationId].personalData.mail
                    ]
                    result.push(wheelChairNotification)
                }
            }
        }
        return result
    }

    getProductsNotifications(){
        const {reservations, events} = this.state
        const result = []
        for (var eventId in events){
            for (var reservationId in reservations[eventId]){
                if (reservations[eventId][reservationId].products){
                    var total = 0
                    var productsNames = ''
                    for (var productIndex in reservations[eventId][reservationId].products){
                        total += reservations[eventId][reservationId].products[productIndex].value
                        productsNames += `${reservations[eventId][reservationId].products[productIndex].name},`
                    }
                    const productsNotifications = [
                        eventId,
                        reservationId,
                        reservations[eventId][reservationId].selectedTime,
                        events[eventId].room.name,
                        productsNames,
                        total,
                        reservations[eventId][reservationId].personalData.name,
                        reservations[eventId][reservationId].personalData.phone,
                        reservations[eventId][reservationId].personalData.mail
                    ]
                    result.push(productsNotifications)
                }
            }
        }
        return result
    }

    getEventsTableData(){
        const {reservations, events} = this.state
        const result = []
        for (var eventId in events){
            var totalguests = 0
            for (var reservationId in reservations[eventId]){
                const guestsFound = reservations[eventId][reservationId].guests.filter(
                    el => {return el.name.length > 0}
                )
                totalguests += guestsFound.length + 1
            }
            const eventRow = [
                eventId,
                events[eventId].client_id,
                events[eventId].name,
                events[eventId].start,
                events[eventId].start,
                events[eventId].end,
                events[eventId].room.name,
                totalguests
            ]
            result.push(eventRow)
        }
        return result
    }

    componentDidUpdate(prevProps, prevState){
        if (prevState.events !== this.state.events){
            // If events change, update reservations
            const eventsIds = Object.keys(this.state.events)
            for (var index in eventsIds){
                Firebase.database().ref(`/guests/${eventsIds[index]}`).on('value', snapshot => {
                    const {reservations} = this.state
                    var reservationsRaw = snapshot.val()
                    const refUrl = snapshot.ref.toString()
                    const eventId = refUrl.substring(refUrl.lastIndexOf('/')+1)
                    reservations[eventId] = reservationsRaw
                    this.setState({
                        reservations: reservations
                    })
                })
            }
        }
    }

    componentDidMount(){
        const ref = Firebase.database().ref('/events')

        ref.orderByChild('end').startAt(new Date().getTime()).once('value', snapshot => {
            var eventsRaw = snapshot.val();
            const eventsOfTheDay = parseEvents(eventsRaw, false)
            ref.off('value')
            this.setState({
                events: eventsOfTheDay,
            })
        })
    }

    render(){
        const {
            wheelChairHeaders,
            productsHeaders,
            eventsHeaders,
            getWheelChairNotifications,
            getProductsNotifications,
            getEventsTableData
        } = this
        const wheelChairData = getWheelChairNotifications()
        const productsData = getProductsNotifications()
        const eventsData = getEventsTableData()
        return (
            <div>
                <div className="events-finder-container">
                    <div className="line-header-text">Silla de ruedas</div>
                    <div>
                        <GenericTable
                            headers={wheelChairHeaders}
                            tableData={wheelChairData}
                            columnOrderIndex={2}
                        />
                    </div>
                </div>
                <div className="events-finder-container">
                    <div className="line-header-text">Productos</div>
                    <div>
                        <GenericTable
                            headers={productsHeaders}
                            tableData={productsData}
                            columnOrderIndex={2}
                        />
                    </div>
                </div>
                <div className="events-finder-container">
                    <div className="line-header-text">Proximos eventos</div>
                    <div>
                        <GenericTable
                            headers={eventsHeaders}
                            tableData={eventsData}
                            columnOrderIndex={3}
                        />
                    </div>
                </div>
            </div>
        )
    }
}

export default NotificationsAdmin
